import { BaseEntity } from './base-entity';


export class ChangePayment{
    public paymentType: string;
    public orderId: string;
}
